exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-mask[data-v-4127895a]{position:fixed;width:100%;height:100%;background:transparent;display:inline-flex;justify-content:center;align-items:center;z-index:99;top:0;left:0}", ""]);

// exports
